import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

/**
 * error state matcher for material form controls
 * Use this to change mat-error default behaviour and show mat-error on control.invalid
 */
export class InvalidErrorStateMatcher implements ErrorStateMatcher {
  public isErrorState(control: UntypedFormControl | null, _form: FormGroupDirective | NgForm | null): boolean {
    return (control && control.invalid);
  }
}
